// LA RENOVACION SILENCIOSA DE LA SESION DEL EQUIPO.
//
// POR QUE EXISTE. El token del equipo duraba 30 DIAS y no se renovaba nunca: al caducar, el
// interceptor de 401 limpiaba la sesion y mandaba al login. Con ese diseno, acortar la caducidad
// era imposible sin hacer que la clinica entera tecleara la contrasena a diario — y por eso duraba
// un mes, que es lo que valia un token robado de `localStorage`.
//
// Con esto, el token dura 12 h y el navegador lo cambia por uno nuevo cada rato mientras la
// aplicacion este abierta. Quien trabaja no ve NADA. El servidor pone el limite de verdad: la
// sesion no se estira mas alla de 7 dias desde que se tecleo la contrasena (ver
// backend/services/sesionEquipo.js) — a partir de ahi, /auth/renovar contesta `renovado:false` y
// toca volver a entrar.
//
// LO QUE NO HACE, A PROPOSITO: no echa a nadie. Si la renovacion falla (sin red, servidor caido,
// techo agotado) no se toca la sesion: el token que ya hay sigue sirviendo hasta que caduque solo,
// y si esta muerto ya se encarga el interceptor de 401. Un fallo de red no puede sacar a nadie de
// la aplicacion en mitad de una consulta.
import api from './api'

// Cada 45 min. El token vive 12 h, asi que se pueden perder muchas renovaciones seguidas (portatil
// dormido, sin cobertura) sin que nadie se quede fuera.
const CADA_MS = 45 * 60 * 1000
// No se pide dos veces seguidas: al volver a la pestana se renueva, pero no si se acaba de hacer.
const MINIMO_ENTRE_MS = 5 * 60 * 1000

let ultima = 0
// A partir de aqui se avisa de que el techo de 7 dias se acaba. Dos horas dan de sobra para
// terminar lo que se este escribiendo y volver a entrar con calma.
const AVISAR_BAJO_MIN = 120
let yaAvisado = false

// EL AVISO SE EMITE COMO EVENTO, no con un toast desde aqui: este fichero es un servicio suelto y
// no tiene el contexto de la aplicacion. Quien pinta es Layout, que si lo tiene.
function avisarSiSeAcaba(restanMin) {
  if (typeof restanMin !== 'number') return
  if (restanMin > AVISAR_BAJO_MIN) { yaAvisado = false; return }
  if (yaAvisado) return                       // una vez por sesion, no en cada renovacion
  yaAvisado = true
  window.dispatchEvent(new CustomEvent('sesion-por-caducar', { detail: { restanMin } }))
}

export async function renovarToken() {
  if (!localStorage.getItem('token')) return null
  ultima = Date.now()
  try {
    const { data } = await api.post('/auth/renovar')
    if (data && data.renovado && data.token) {
      localStorage.setItem('token', data.token)
      avisarSiSeAcaba(data.restan_min)
      return data.token
    }
    // Techo agotado: el token actual sigue sirviendo hasta que caduque, pero ya no se renovara mas.
    // Decirlo es la diferencia entre "vuelve a entrar cuando puedas" y quedarse fuera de golpe.
    if (data && data.renovado === false) avisarSiSeAcaba(0)
  } catch (_) { /* sin red: se sigue con el token actual, y no se avisa de nada */ }
  return null
}

/**
 * Arranca la renovacion periodica. Devuelve la funcion para pararla (para el cleanup del efecto).
 * `alRenovar` recibe el token nuevo, para que el contexto lo tenga en su estado ademas de en
 * localStorage (si no, un componente que lea `token` del contexto seguiria con el viejo).
 */
export function arrancarRenovacion(alRenovar) {
  const hacer = async () => {
    const t = await renovarToken()
    if (t && typeof alRenovar === 'function') alRenovar(t)
  }
  // Al arrancar la aplicacion: es el momento en que mas probable es que el token venga de una
  // pestana que lleva horas cerrada.
  hacer()
  const reloj = setInterval(hacer, CADA_MS)
  // Y al volver a la pestana: un portatil que ha estado dormido no ha ejecutado ningun intervalo.
  const alVolver = () => {
    if (document.visibilityState === 'visible' && Date.now() - ultima > MINIMO_ENTRE_MS) hacer()
  }
  document.addEventListener('visibilitychange', alVolver)
  return () => {
    clearInterval(reloj)
    document.removeEventListener('visibilitychange', alVolver)
  }
}
